import React from 'react';
import moment from 'moment';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import { palette } from 'shared/constants/colorsConstants.js';
import tooltipStyles from 'shared/components/andtComponents/Tooltip.module.scss';

const CustomXTick = ({ x, y, payload, overrideWidth, isDateChart }) => {
  const tickValue = isDateChart ? moment(payload.value).format('MMM') : payload.value;
  const maxLength = overrideWidth ? overrideWidth / 5 : 0;
  const shouldTruncate = tickValue.length > maxLength;
  const maxMidpoint = 18;
  let firstLine = tickValue;
  let secondLine = '';

  if (shouldTruncate) {
    const midpoint = Math.min(Math.ceil(tickValue.length / 2), maxMidpoint);
    const beforeMid = tickValue.lastIndexOf(' ', midpoint);
    const afterMid = tickValue.indexOf(' ', midpoint + 1);
    const splitPoint = beforeMid !== -1 ? beforeMid : afterMid;

    firstLine = splitPoint !== -1 ? tickValue.substring(0, splitPoint) : tickValue.substring(0, midpoint);
    secondLine = splitPoint !== -1 ? tickValue.substring(splitPoint + 1) : tickValue.substring(midpoint + 1);

    if (secondLine.length > maxMidpoint) {
      secondLine = secondLine.substring(0, maxMidpoint) + '...';
    }
  }

  return (
    <Tooltip
      title={tickValue.length > maxLength ? tickValue : null}
      arrow
      classes={{
        tooltip: tooltipStyles.whiteTooltip,
        arrow: tooltipStyles.whiteArrow,
        content: tooltipStyles.tooltipText,
      }}
    >
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={7}
          dy={12}
          textAnchor="middle"
          fill={palette.gray[400]}
          width={overrideWidth || tickValue.length * 6}
        >
          <tspan x="0" dy="0">
            {firstLine}
          </tspan>
          {secondLine && (
            <tspan x="0" dy="15">
              {secondLine}
            </tspan>
          )}
        </text>
      </g>
    </Tooltip>
  );
};
export default CustomXTick;
